module.exports = __webpack_public_path__ + "completed.2cca0179.svg";